import { HttpContextToken } from '@angular/common/http';

export const EXCLUDE_SPINNER = new HttpContextToken<boolean>(() => false);
